import { useQueryState, parseAsString } from 'nuqs'
import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import useQueryOperatorDepositTransactions from '@/modules/bank/api/hooks/useQueryOperatorDepositTransactions'
import OperatorDepositListing from '@/modules/bank/components/OperatorDeposit/components/OperatorDepositListing'

function OperatorDepositPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [status] = useQueryState('status', parseAsString)

	const { dateFilter } = useDateFilter()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		paymentGatewayId: searchQuery || undefined,
		status: status || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	const { data, refetch, isLoading } =
		useQueryOperatorDepositTransactions(payload)

	const depositList = data?.data || []
	const totalDeposits = data?.total || 0

	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<OperatorDepositListing
					data={depositList}
					total={totalDeposits}
					onRefresh={refetch}
					isLoading={isLoading}
					onSort={undefined}
				/>
			</div>
		</PageContainer>
	)
}

export default OperatorDepositPage
